import React from 'react';

import { NeedsListPage } from '../../shared/needs';
import { ORGANIZATION_NEEDS_LIST_QUERY_KEY } from './queryKeys';

const NeedsList: React.FC = () => {
  return (
    <NeedsListPage
      title="Needs"
      queryKeyBase={ORGANIZATION_NEEDS_LIST_QUERY_KEY}
      displayTypePrefKey="OrganizationNeeds"
      showOrganization={false}
    />
  );
};

export default NeedsList;
